// easify-soldout-guard.js
// Checks DEFAULT (hidden/prechecked) add-on products once.
// If any are out of stock -> disable ATC + show "Sold out" + message.
// Adapted for Easify Product Options:
//  - MutationObserver re-applies state if Easify/theme re-renders the buttons
//  - fetch/XHR guard blocks AJAX /cart/add calls while sold out

(() => {


  const DEFAULT_ADDON_HANDLES = [
    "working-french-shaft-tugs",
    "jog-lines-with-cord-and-pully-front",
    "work-snap-traces",
    "work-breast-collar-and-neck-strap",
    "adjustable-side-reins-with-snap-ends",
    "work-balance-strap",
    "work-shaft-tug-bearer-straps",
    "advantage-comfort-training-crupper",
    "advantage-comfort-training-backstrap",
    "advantage-comfort-training-padded-martingale",
       ];

  const SOLD_OUT_TEXT = "Sold Out";
  //const SOLD_OUT_MESSAGE =
    //"This set is temporarily unavailable — a component is out of stock. Please check back soon.";

  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function getATCForms() {
    return qsa('form[action*="/cart/add"]');
  }

  function getButtons(form) {
    const atc =
      qs('button[name="add"]', form) ||
      qs('button[type="submit"]', form) ||
      qs('input[type="submit"]', form);

    const buyNow =
      qs('.shopify-payment-button button', form) ||
      qs('[data-shopify="payment-button"] button', form);

    return { atc, buyNow };
  }

  function setBtn(btn, ok) {
    if (!btn) return;

    if (!btn.dataset.qhOriginalText) {
      btn.dataset.qhOriginalText =
        btn.tagName.toLowerCase() === "input" ? (btn.value || "") : (btn.textContent || "");
    }
    const original = (btn.dataset.qhOriginalText || "Add to cart").trim();

    if (ok) {
      btn.disabled = false;
      btn.removeAttribute("aria-disabled");
      btn.classList.remove("is-soldout");
      if (btn.tagName.toLowerCase() === "input") {
        if (btn.value === SOLD_OUT_TEXT) btn.value = original;
      } else if (btn.textContent.trim() === SOLD_OUT_TEXT) {
        btn.textContent = original;
      }
    } else {
      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("is-soldout");
      if (btn.tagName.toLowerCase() === "input") {
        if (btn.value !== SOLD_OUT_TEXT) btn.value = SOLD_OUT_TEXT;
      } else if (btn.textContent.trim() !== SOLD_OUT_TEXT) {
        btn.textContent = SOLD_OUT_TEXT;
      }
    }
  }

  // function setMessage(form, show) {
  //   let msg = form.querySelector(".qh-soldout-message");
  //   if (show) {
  //     if (!msg) {
  //       msg = document.createElement("p");
  //       msg.className = "qh-soldout-message";
  //       msg.style.cssText =
  //         "color:#b00020;font-size:0.9em;margin:8px 0 0;line-height:1.4;";
  //       msg.textContent = SOLD_OUT_MESSAGE;
  //       const { atc } = getButtons(form);
  //       if (atc && atc.parentNode) {
  //         atc.parentNode.insertBefore(msg, atc.nextSibling);
  //       } else {
  //         form.appendChild(msg);
  //       }
  //     }
  //   } else if (msg) {
  //     msg.remove();
  //   }
  // }

  async function handleIsAvailable(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!res.ok) return false;
      const p = await res.json();
      return Array.isArray(p.variants) ? p.variants.some(v => v && v.available) : false;
    } catch (e) {
      return false;
    }
  }

  async function computeSoldOut() {
    const results = await Promise.all(DEFAULT_ADDON_HANDLES.map(handleIsAvailable));
    return results.some(ok => ok === false);
  }

  function applySoldOutState() {
    const soldOut = window.__qhSoldOut === true;
    getATCForms().forEach(form => {
      const { atc, buyNow } = getButtons(form);

      // Skip buttonless forms (e.g. hidden installments form)
      if (!atc && !buyNow) return;

      setBtn(atc, !soldOut);
      setBtn(buyNow, !soldOut);
      setMessage(form, soldOut);

      // Belt-and-braces: block plain form submits
      if (!form.__qhSubmitGuard) {
        form.__qhSubmitGuard = true;
        form.addEventListener("submit", (e) => {
          if (window.__qhSoldOut === true) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }
    });
  }

  // Block AJAX add-to-cart while sold out.
  // Easify/themes add items via fetch or XHR to /cart/add(.js),
  // which never fires a form "submit" event.
  function installFetchGuard() {
    if (window.__qhFetchGuard) return;
    window.__qhFetchGuard = true;

    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        if (window.__qhSoldOut === true && url.includes("/cart/add")) {
          return Promise.reject(new Error("Blocked: default add-on sold out"));
        }
      } catch (e) { /* fall through */ }
      return origFetch.apply(this, arguments);
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__qhCartAdd = typeof url === "string" && url.includes("/cart/add");
      return origOpen.apply(this, arguments);
    };
    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (window.__qhSoldOut === true && this.__qhCartAdd) {
        this.abort();
        return;
      }
      return origSend.apply(this, arguments);
    };
  }

  // Re-apply state whenever Easify or the theme re-renders the form area
  // (e.g. theme JS restoring the button label via data-add-to-cart-text).
  function installObserver() {
    let t = null;
    const obs = new MutationObserver(() => {
      if (window.__qhSoldOut !== true) return;
      clearTimeout(t);
      t = setTimeout(applySoldOutState, 100);
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  async function init() {
    window.__qhSoldOut = await computeSoldOut();

    installFetchGuard();
    applySoldOutState();
    installObserver();

    // A few timed retries in case Easify injects/re-renders the form late
    for (let i = 0; i < 12; i++) {
      await new Promise(r => setTimeout(r, 250));
      applySoldOutState();
      if (getATCForms().length && i > 3) break;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();